import React from "react";
import TestimonialCard from "./testimonialcard";

const TestimonialUser1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";
const testimonials = [
  {
    name: "Dr. Priya Sharma",
    content:
      "This platform has revolutionized my diagnostic process. The clinical case simulation tool is incredibly helpful in making accurate assessments.",
    image: TestimonialUser1,
    username: "dr.priya.sharma",
  },
  {
    name: "Ravi Kumar",
    content:
      "As a medical student, I love how I can search symptoms and quickly match them with possible diseases. It’s a great tool for learning.",
    image: TestimonialUser1,
    username: "ravikumar_meds",
  },
  {
    name: "Neha Reddy",
    content:
      "The ability to generate quick notes for patients is a game changer for me as a healthcare professional. I can easily create detailed summaries and download them.",
    image: TestimonialUser1,
    username: "neha_reddy",
  },
  {
    name: "Vikram Singh",
    content:
      "As someone who regularly faces complex clinical cases, I find this platform's simulation feature indispensable. It saves me time and sharpens my diagnostic skills.",
    image: TestimonialUser1,
    username: "vikram_singh",
  },
  {
    name: "Dr. Ananya Verma",
    content:
      "The search functionality for diseases based on symptoms has been invaluable in the clinic. I feel more confident in my diagnoses, and patients benefit as a result.",
    image: TestimonialUser1,
    username: "dr.ananya.verma",
  },
  {
    name: "Sandeep Yadav",
    content:
      "I’ve used many diagnostic tools in the past, but this one stands out. The user interface is clean and intuitive, and the clinical cases are realistic and helpful.",
    image: TestimonialUser1,
    username: "sandeep_yadav",
  },
  {
    name: "Aishwarya Desai",
    content:
      "I love how I can explore different case scenarios and refine my skills. The ability to search symptoms and diseases together is a fantastic feature.",
    image: TestimonialUser1,
    username: "aishwarya_desai",
  },
  {
    name: "Rahul Patel",
    content:
      "This platform helped me immensely during my clinical internship. The cases are very well-structured, and the quick note generation has improved my workflow.",
    image: TestimonialUser1,
    username: "rahul_patel",
  },
  {
    name: "Dr. Meera Iyer",
    content:
      "The platform is very user-friendly. I appreciate how easy it is to search for symptoms and quickly generate relevant disease information.",
    image: TestimonialUser1,
    username: "dr.meera.iyer",
  },
  {
    name: "Arjun Saini",
    content:
      "As a healthcare assistant, the disease search feature helps me understand conditions better. The downloadable notes are useful for patient consultations.",
    image: TestimonialUser1,
    username: "arjun_saini",
  },
];

export default function TestimonialsRow() {
  return (
    <div className="portfoliotestimonialsrow">
      {testimonials.map((testimonial, index) => (
        <TestimonialCard
          key={index}
          name={testimonial.name}
          content={testimonial.content}
          image={testimonial.image}
          username={testimonial.username}
        />
      ))}
    </div>
  );
}
